// extracted by mini-css-extract-plugin
export default {"wrapper":"ConsistencyCheckHistoryDetails_wrapper__ffGkY"};